import ReportCard from "./ReportCard";
import Stat from "./Stat";
import {ComplainsTableFilterNew, ComplainsTableRow, TableHeader, TablePagination} from "../../components/table";
import {InputAdornment, Table, TableBody, TableContainer, TextField} from "@mui/material";
import {APP_URLS, complainsTableHead} from "../../app/config";
import _ from "lodash";
import React, {useEffect, useState} from "react";
import {Search} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import { apiClient } from "../../providers/apiClient";
import {TailSpin} from "react-loader-spinner";
import {StatsStatuses} from "../../app/config/complainStatuses";
import useComplaints from "../../hooks/useComplaints";

const defaultStats = {
    totalComplaints: 0,
    complaintsClosedCount: 0,
    complaintsClosedAutomatically: 0,
    complaintsManuallyClosedTotal: 0,
    complaintsManuallyClosedSuccessfully: 0,
    complaintsManuallyClosedUnsuccessfully: 0,
    publicComplaintsRatio: 0,
    closedSuccessfully: 0,
    complaintsWithCompanyAnswer: 0,
    averageResponseTime: 0,
    createdCases: {
        thisMonth: 0,
        thisYear: 0,
        fromBeginning: 0
    },
    closedSuccessfullyCases: {
        thisMonth: 0,
        thisYear: 0,
        fromBeginning: 0
    },
    closedUnsuccessfullyCases: {
        thisMonth: 0,
        thisYear: 0,
        fromBeginning: 0
    }
}


const CasesTab = () => {
    const [open, setOpen] = useState(null);
    const [activeFilter, setActiveFilter] = useState(0);
    const {t: tPages} = useTranslation('Pages');
    const [stats, setStats] = useState(defaultStats);
    const [isLoading, setIsLoading] = useState(true);

    const {
        data: complains,
        filter,
        setFilter: hookSetFilter,
        pagination,
        nextPage,
        previousPage,
        resetFilters,
        refresh,
    } = useComplaints();
    const [selectedItems, setSelectedItems] = useState([]);

    let timer = null;

    useEffect(() => {
        setIsLoading(true);

        apiClient.get(APP_URLS.COMPLAIN_STATS).then(response => {
            setStats(response.data);
            setIsLoading(false);
        })
    }, []);

    const handlePreviousPage = () => {
        previousPage();
    }

    const handleNextPage = () => {
        nextPage();
    }

    const clearFilters = () => {
        resetFilters();
        setSelectedItems([]);
    }

    const filterCaseCreated = (currentPeriod, success, filterNumber) => {
        setActiveFilter(filterNumber);
        let firstDay;

        const dateTo = new Date();

        switch (currentPeriod) {
            case 'month': {
                firstDay = new Date(dateTo.getFullYear(), dateTo.getMonth(), 1);
                break;
            }
            case 'year': {
                firstDay = new Date(dateTo.getFullYear(), 0, 1);
                break;
            }
            case 'start': {
                firstDay = null;
                break;
            }
        }

        hookSetFilter('status', success ?? null);
        hookSetFilter('dateFrom', firstDay);
        hookSetFilter('dateTo', dateTo);
        hookSetFilter('pageNumber', 1);
    }

    const handleRequestSort = (event, property) => {
        const direction =
            filter.orderBy === property &&
            filter.orderDirection === "asc"
                ? "desc"
                : "asc";
        hookSetFilter('orderBy', property);
        hookSetFilter('orderDirection', direction);
    }

    const handleRowCheck = (item, isChecked) => {
        if (!isChecked) {
            setSelectedItems(prev => [...prev, item]);
        } else {
            setSelectedItems(prev => prev.filter(i => i.id !== item.id));
        }
    }

    const handleSelectAll = () => {
        if (selectedItems.length === complains.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems([...complains]);
        }
    }

    const handleRowClick = (id) => {
        setOpen(prev => prev === id ? null : id);
    }

    const searchIcon = {
        endAdornment:
            <InputAdornment position="end">
                <Search/>
            </InputAdornment>
    };

    const handleFilterChange = (field, value) => {
        clearTimeout(timer);

        timer = setTimeout(() => {
            hookSetFilter(field, value);
        }, 500);
    };

    const handleMergeFinished = () => {
        setSelectedItems([]);
        refresh();
    }

    if(isLoading) {
        return (
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100vw', height: '80vh'}}>
                <TailSpin
                    visible={true}
                    height="80"
                    width="80"
                    color="#4fa94d"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                />
            </div>
        )
    }


    return (
        <div className="fk-screen">
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', padding: 24}}>
                <TextField
                    className="fk-input"
                    variant="outlined"
                    placeholder={tPages('searchFieldLabel')}
                    InputProps={searchIcon}
                    value={filter.search}
                    onChange={(event) => handleFilterChange('search', event.target.value)}
                />
            </div>


            <div style={{display: 'flex', flexDirection: 'row'}}>
                <span className="rowHeaderText">Quick filters </span>
                <span style={{color: '#B2B2B2', marginLeft: 12, cursor: 'pointer'}} onClick={clearFilters}>Clear filters</span>
            </div>


            <div className="rowContainer">
                <ReportCard label={'Cases created'} isLoading={isLoading}>
                    <Stat value={stats?.createdCases?.thisMonth}
                          description={"this month"}
                          onClick={filterCaseCreated}
                          period={'month'}
                          filterNumber={1}
                          activeFilter={activeFilter}
                    />

                    <Stat value={stats?.createdCases?.thisYear}
                          description={"this year"}
                          onClick={filterCaseCreated}
                          period={'year'}
                          filterNumber={2}
                          activeFilter={activeFilter}
                    />
                    <Stat value={stats?.createdCases?.fromBeginning}
                          description={"since beginning"}
                          onClick={filterCaseCreated}
                          period={'start'}
                          filterNumber={3}
                          activeFilter={activeFilter}
                    />
                </ReportCard>

                <ReportCard label={'Cases completed successfully'} isLoading={isLoading}>
                    <Stat value={stats?.closedSuccessfullyCases?.thisMonth}
                          description={"this month"}
                          onClick={filterCaseCreated}
                          period={'month'}
                          filterNumber={4}
                          activeFilter={activeFilter}
                          status={StatsStatuses.AllClosedResolved}
                    />
                    <Stat value={stats?.closedSuccessfullyCases?.thisYear}
                          description={"this year"}
                          onClick={filterCaseCreated}
                          period={'year'}
                          filterNumber={5}
                          activeFilter={activeFilter}
                          status={StatsStatuses.AllClosedResolved}
                    />

                    <Stat value={stats?.closedSuccessfullyCases?.fromBeginning}
                          description={"since beginning"}
                          onClick={filterCaseCreated}
                          period={'start'}
                          filterNumber={6}
                          activeFilter={activeFilter}
                          status={StatsStatuses.AllClosedResolved}
                    />
                </ReportCard>

                <ReportCard label={'Cases ended unsuccessfully'} isLoading={isLoading}>
                    <Stat value={stats?.closedUnsuccessfullyCases?.thisMonth}
                          description={"this month"}
                          onClick={filterCaseCreated}
                          period={'month'}
                          filterNumber={7}
                          activeFilter={activeFilter}
                          status={StatsStatuses.AllClosedUnresolved}
                    />
                    <Stat value={stats?.closedUnsuccessfullyCases?.thisYear}
                          description={"this year"}
                          onClick={filterCaseCreated}
                          period={'year'}
                          filterNumber={8}
                          activeFilter={activeFilter}
                          status={StatsStatuses.AllClosedUnresolved}
                    />
                    <Stat value={stats?.closedUnsuccessfullyCases?.fromBeginning}
                          description={"since beginning"}
                          onClick={filterCaseCreated}
                          period={'start'}
                          filterNumber={9}
                          activeFilter={activeFilter}
                          status={StatsStatuses.AllClosedUnresolved}
                    />
                </ReportCard>
            </div>

            <ComplainsTableFilterNew
                filter={filter}
                setFilter={handleFilterChange}
                selectedItems={selectedItems}
                onMergeFinished={handleMergeFinished}
                hideSearch
            />
            <TableContainer>
                <Table size="medium" className="fk-table">
                    <TableHeader
                        crud
                        withCheckbox
                        items={complainsTableHead}
                        orderBy={filter.orderBy}
                        order={filter.orderDirection}
                        numSelected={selectedItems.length}
                        rowCount={complains.length}
                        onRequestSort={handleRequestSort}
                        onSelectAllClick={handleSelectAll}
                        screen="ComplainsScreen"
                    />
                    <TableBody>
                        {complains.map((complain) => {
                            const isChecked = _.some(selectedItems, (item) => item.id === complain.id);

                            return (
                                <ComplainsTableRow
                                    key={complain.id}
                                    checked={isChecked}
                                    open={open === complain.id}
                                    complain={complain}
                                    columns={complainsTableHead}
                                    onCheck={() => handleRowCheck(complain, isChecked)}
                                    onRowClick={handleRowClick}
                                />
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                filter={{...filter, ...pagination}}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
            />
        </div>
    )
}

export default CasesTab;
